import { jsxs, jsx } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils/common';
import { useMergedCSS } from '@flex-design-system/stitches-react';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { forwardRef, useMemo } from 'react';
import usePopperPresence from '../../../../hooks/usePopperPresence.mjs';
import { usePopperZIndexStyle } from '../../../../hooks/usePopperZIndexStyle.mjs';
import { overlayStyle } from '../../../../utils/css.mjs';
import InjectAside from '../../../utility/InjectAside.mjs';
import { useModalContext } from '../../context.mjs';
import { StyledOverlay, StyledContentPositioner } from '../../styled.mjs';
import { StyledContent_Legacy, ContentRoot_Legacy } from './styled.mjs';

const ModalContent_Legacy = forwardRef(
  (props, forwardedRef) => {
    const {
      children,
      leftAside,
      rightAside,
      overlayTheme = "light",
      css: cssFromProps,
      portalContainer: portalContainerFromProps,
      zIndex,
      ...restProps
    } = props;
    const {
      modal,
      open,
      onClose,
      hasLeftAsideChildren,
      hasRightAsideChildren,
      onChangeModalContentElement,
      portalContainerElement: portalContainerElementFromContext
    } = useModalContext("Modal.Content_Legacy");
    const { ref: presenceRef } = usePopperPresence({
      open,
      onPresenceChange: (isPresent) => !isPresent && onClose?.()
    });
    const composedRef = useComposedRefs(
      forwardedRef,
      presenceRef,
      onChangeModalContentElement
    );
    const portalContainer = portalContainerFromProps ?? portalContainerElementFromContext;
    const positionStyle = useMemo(() => {
      if (isNil(portalContainer)) {
        return;
      }
      return { position: "absolute" };
    }, [portalContainer]);
    const zIndexStyle = usePopperZIndexStyle(open, zIndex);
    const positionerCSS = useMergedCSS(positionStyle, zIndexStyle);
    return /* @__PURE__ */ jsxs(DialogPrimitive.Portal, { container: portalContainer, children: [
      /* @__PURE__ */ jsx(
        StyledOverlay,
        {
          className: overlayStyle({ overlayTheme }),
          css: positionerCSS
        }
      ),
      /* @__PURE__ */ jsx(
        StyledContentPositioner,
        {
          placement: "center",
          css: positionerCSS,
          modal,
          children: /* @__PURE__ */ jsxs(
            StyledContent_Legacy,
            {
              css: cssFromProps,
              ref: composedRef,
              ...restProps,
              children: [
                leftAside ? /* @__PURE__ */ jsx(InjectAside, { side: "left", children: leftAside }) : null,
                /* @__PURE__ */ jsx(
                  ContentRoot_Legacy,
                  {
                    layout: hasLeftAsideChildren || hasRightAsideChildren ? "column" : void 0,
                    children
                  }
                ),
                rightAside ? /* @__PURE__ */ jsx(InjectAside, { side: "right", children: rightAside }) : null
              ]
            }
          )
        }
      )
    ] });
  }
);

export { ModalContent_Legacy as default };
//# sourceMappingURL=Content_Legacy.mjs.map
